module.exports = __webpack_public_path__ + "static/media/thumb2016.a8b0ba85.png";